import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import Axios from '../../../axios/axios';
import SupplierNavbar from './SuppplierNavbar';
import SupplierSidebar from './SupplierSidebar';
import { Table } from 'react-bootstrap';

function SupplierPaymentList() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const statusFilter = queryParams.get('status'); // 'Pending' or 'Settled'

  const [payments, setPayments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const supplierInfo = JSON.parse(sessionStorage.getItem('supplierInfo'));
  const supplierId = supplierInfo?.supplierId;

  useEffect(() => {
    if (window.innerWidth < 768) setSidebarOpen(false);
  }, []);

  useEffect(() => {
    const fetchPayments = async () => {
      try {
  let endpoint = '';

if (statusFilter === 'Settled') {
  endpoint = `/supplier/settled-payments/${supplierId}`;
} else {
  endpoint = `/supplier/pending-payments/${supplierId}`;
}

const res = await Axios.get(endpoint);
setPayments(res.data.payments || []);

      } catch (error) {
        console.error('Error fetching payments:', error);
      } finally {
        setLoading(false);
      }
    };

    if (supplierId) fetchPayments();
  }, [supplierId, statusFilter]);

  const formatCurrency = (amount) =>
    new Intl.NumberFormat('en-IN', {
      style: 'currency',
      currency: 'AED',
    }).format(amount);

  return (
    <>
      <SupplierNavbar
        supplier={supplierInfo}
        toggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />
      <div className="container-fluid">
        <div className="row">
          {sidebarOpen && (
            <div className="col-md-2">
              <SupplierSidebar closeSidebar={() => setSidebarOpen(false)} />
            </div>
          )}
          <div className="col-md-10">
            <div className="dashboard-main p-4">
              <h2>{statusFilter} Payments</h2>
              {loading ? (
                <p>Loading...</p>
              ) : payments.length > 0 ? (
                <Table striped bordered hover>
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Order ID</th>
                      {/* <th>Amount</th> */}
                      <th>Unit Price</th>
<th>Total Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    {payments.map((payment) => (
                      <tr key={payment._id}>
                        <td>{new Date(payment.date).toLocaleDateString()}</td>
                        <td>{payment.orderId}</td>
                        {/* <td>{formatCurrency(payment.amount)}</td> */}
                        <td>{formatCurrency(payment.unitPrice)}</td>
<td>{formatCurrency(payment.totalPrice)}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <p>No {statusFilter} payments found.</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SupplierPaymentList;
